export default "__VITE_ASSET__fdl1$TUc__"